import React, { useState } from 'react';
import { Link } from 'gatsby';
import LogoMaroon from '../images/UChicago-logo-maroon.svg';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles/navBarMobile.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faClose, faChevronDown, faChevronUp, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import NavBarTop from "./navBarTop";


const NavBarMobile = ({ menuItems }) => {

    const [hoveredNav] = useState(null);
    const [hoveredSubNavItem, setHoveredSubNavItem] = useState(null);
    // State to manage if the menu is shown or not
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [openSubMenuName, setOpenSubMenuName] = useState(null);
    const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);
    // Function to toggle the menu
    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);

    };
    const toggleSubMenu = (name) => {
        setOpenSubMenuName(currentName => currentName === name ? null : name);
        setIsSubMenuOpen(!isSubMenuOpen);
    };
    return (
        <>
            <Container fluid className="mobile">
                <Container><Row><Col xs={6} sm={6}>
                    <Link to="/">
                        <img src={LogoMaroon} alt="The University of Chicago Career Advancement" className="navbar-logo" />
                    </Link>
                </Col>
                    <Col xs={6} className="hamburger">
                        <button onClick={toggleMenu} aria-label={isMenuOpen ? "Close menu" : "Open menu"} tabIndex="0">
                            <FontAwesomeIcon icon={isMenuOpen ? faClose : faBars} />
                        </button>

                    </Col>
                </Row></Container>

                {isMenuOpen && (
                    <Container fluid>
                        <Container>
                            <nav>
                                <Row><Col>
                                    <ul >
                                        {menuItems.sort((a, b) => a.navOrder - b.navOrder).map((menuItem) => {
                                            if (menuItem.navLocation.includes('Main Navigation')) {
                                                return (
                                                    <li key={menuItem.navGroupName} className="first-level">
                                                        
                                                        <button onClick={() => toggleSubMenu(menuItem.navGroupName)} aria-label={openSubMenuName === menuItem.navGroupName ? "Close submenu" : "Open submenu"} tabIndex={0}>
                                                        {menuItem.navGroupName}

                                                            <FontAwesomeIcon icon={openSubMenuName === menuItem.navGroupName ? faChevronUp : faChevronDown} />
                                                        </button>

                                                        {openSubMenuName === menuItem.navGroupName && (
                                                            <SubNav
                                                                navNextLevel={menuItem.navNextLevel}
                                                                basePath={`/${menuItem.navSlug}`}
                                                                name={menuItem.navGroupName}
                                                            />
                                                        )}
                                                    </li>
                                                );
                                            }
                                            return null;
                                        })}
                                    </ul>
                                </Col></Row>
                            </nav>
                            <NavBarTop menuItems={menuItems} />
                        </Container>
                    </Container>
                )}
            </Container>
        </>
    );
};

const SubNav = ({ navNextLevel, basePath, name }) => {
    if (!navNextLevel || navNextLevel.length === 0) {
        return null;
    }

    return (
        <>
            <Container name={name}>
                <Row>
                    <Col>
                        <ul className="sub-nav-levels">
                            {navNextLevel.map((subNav) => (

                                <li key={subNav.navItemName} className="first-level">
                                    <ul>
                                        <li>
                                            <Col>
                                                {subNav.showhideName && (

                                                    <>
                                                        {basePath === '/career-toolkit' || basePath === '/student-opportunities' ? (
                                                            <p className="first-level-link">{subNav.navItemName}</p>
                                                        ) : (
                                                            <Link
                                                                to={`${basePath}/${subNav.navSlug}`}
                                                                className="first-level-link"
                                                            >
                                                                {subNav.navItemName} 
                                                            </Link>
                                                        )}
                                                        {(subNav.navNextLevel && basePath != '/hire-uchicago') ?
                                                            <ul>
                                                                {subNav.navNextLevel.map((subSubNav) =>
                                                                    <li><Link to={`${basePath}/${subNav.navSlug}/${subSubNav.navSlug}`}>{subSubNav.navItemName} </Link></li>
                                                                )}
                                                            </ul> : null}


                                                        {basePath === '/hire-uchicago' && (
                                                            subNav.navDescription) ?
                                                            <p>
                                                                {subNav.navDescription.length > 80
                                                                    ? `${subNav.navDescription.substring(0, 80)} ...`
                                                                    : subNav.navDescription}
                                                                {subNav.navDescription.length > 80 && <span>...</span>}
                                                            </p>
                                                            : null
                                                        }

                                                    </>
                                                )}
                                            </Col>
                                        </li>
                                    </ul>
                                </li>
                            ))}
                        </ul>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default NavBarMobile;